import { render, staticRenderFns } from "./OpinionAnalysisManager.vue?vue&type=template&id=70c8bff5&"
import script from "./OpinionAnalysisManager.vue?vue&type=script&lang=js&"
export * from "./OpinionAnalysisManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports